import { BackgroundToLightnessProvider, Spinner } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'

const LoadingSpinner = () => {
  return (
    <div className={styles.loadingContainer}>
      <BackgroundToLightnessProvider background="grey1000">
        <Spinner size="s40" />
      </BackgroundToLightnessProvider>
    </div>
  )
}

export default LoadingSpinner
